import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../../SvgIcons/CreateIconComponent';

export type FlowerRoseIconProps = CreateIconComponentProps;
export const FlowerRoseIcon: React.FC<FlowerRoseIconProps> = ({
  title = 'FlowerRose',
  viewBox = '0 0 24 24',
  ...rest
}) => (
  <CreateIconComponent title={title} viewBox={viewBox} {...rest} fill="none">
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M13.062 12.947c.863-4.255-1.887-7.005-6.142-6.142"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M13.062 12.947c-4.256.863-7.006-1.887-6.142-6.142M7.924 3.79c2.87-.581 5.055.48 5.91 2.538M7.924 3.79c-.173.855-.2 1.649-.1 2.365M17.08 6.805c-1.979-.402-3.632-.022-4.748.928M17.08 6.805c.68 3.351-.88 5.768-3.653 6.223M16.076 2.786c-1.726-.35-3.204-.106-4.294.592M16.076 2.786c.264 1.301.19 2.462-.162 3.421M13 14v8M12.59 19.267c-.19-3.086-2.589-4.471-5.357-3.093M12.59 19.267c-2.768 1.378-5.166-.007-5.357-3.093M13.31 19.267c.19-3.086 2.588-4.471 5.356-3.093M13.31 19.267c2.768 1.378 5.166-.007 5.356-3.093"
    />
  </CreateIconComponent>
);
